<div class="container-fluid mx-0">
  <div class="d-flex justify-content-between">
    <div class="col-12 col-md-12 col-lg px-0 mx-0 mb-1">
      <div class="btn-group me-2" role="group">
        <div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="emitDateChange()">
          <fa-icon class="d-block" icon="chevron-left"></fa-icon>
        </div>
        <div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="emitDateChange()">
          <fa-icon class="d-block" icon="chevron-right"></fa-icon>
        </div>
      </div>
      <div
        class="btn"
        mwlCalendarToday
        [ngClass]="{ 'btn-primary': isToday, 'btn-secondary': !isToday }"
        [(viewDate)]="viewDate"
        (viewDateChange)="emitDateChange()"
        >
        Aujourd'hui
      </div>
    </div>
    <div class="col-12 col-md-12 col-lg mb-1 d-flex justify-content-center">
      <h3 class="text-secondary">{{ viewDate | calendarDate : view + 'ViewTitle' : 'fr' }}</h3>
    </div>
    <div class="col-12 col-md-12 col-lg mb-1 me-0 px-0 d-flex justify-content-end">
      <div class="btn-group">
        <div class="btn btn-secondary" (click)="setView(calendarView.Month)" [class.active]="view === calendarView.Month">Mois</div>
        <div class="btn btn-secondary" (click)="setView(calendarView.Week)" [class.active]="view === calendarView.Week">Semaine</div>
        <div class="btn btn-secondary" (click)="setView(calendarView.Day)" [class.active]="view === calendarView.Day">Jour</div>
      </div>
    </div>
  </div>
  <div>
    @switch (view) {
      @case (calendarView.Month) {
        <mwl-calendar-month-view
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          (dayClicked)="dayClicked($event.day)"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          >
        </mwl-calendar-month-view>
      }
      @case (calendarView.Week) {
        <mwl-calendar-week-view
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          [dayStartHour]="7"
          [dayEndHour]="21"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          >
        </mwl-calendar-week-view>
      }
      @case (calendarView.Day) {
        <mwl-calendar-day-view
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          [dayStartHour]="7"
          [dayEndHour]="21"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          >
        </mwl-calendar-day-view>
      }
    }
  </div>
</div>
